// import { blogCard } from "./ResourceGrid";
// import { CardGeneral } from "../../../component";
import FeaturedCard from "@/components/server/FeaturedCard/FeaturedCard";
import { CardGeneral } from "../../server/CardGeneral/CardGeneral";

import "./ResourceGrid.css";
// import FeaturedCard from "./FeaturedCard";
export interface blogPanelProps {
  cards: any;
  activeTab?: number; // The current active tab
  loadMoreText?: string; // Text for the load more button
  loadMoreHandler?: () => void; // Function to load more cards
  showLoadMore?: boolean;
  imageType?: "asImage" | "asBackground"; // Type of image display
  lang?: string;
  noResultsText?: string;
}

export const BlogPanel = ({
  cards,
  activeTab,
  loadMoreText = 'Load More Results',
  loadMoreHandler,
  showLoadMore = false,
  imageType = "asImage",
  lang,
  noResultsText = "No Results",
}: blogPanelProps) => {
  if(!cards) return null;
  if (cards?.length === 0)
    return <p>{noResultsText}</p>;

  const [featuredCard, ...otherCards] = cards; // Separate featured and other cards

  return (
    <div className="t2-resource-grid__blog-cards">
      {featuredCard && <FeaturedCard {...featuredCard} truncate truncateLength={135} imageType={imageType} />}
      <div className="rc-resource-grid__blog-card-grid">
        {cards?.map((card: any, index: number) => {
          return (
            <div key={`blog-card-${index}`} className={`rc-resource-grid__blog-card ${index === 0 ? "xl:hidden" : ""}`}>
          <CardGeneral
            key={`blog-card-${index}`}
            lang={lang}
            {...card}
            eyebrowIcon={card?.eyebrowIcon}
            eyebrow={card?.eyebrow}
            buttonLabel={card?.buttonLabel || "Read More"}
            imageType="asImage"
            truncate
            truncateLength={135}
          />
          </div>
          )
      })}
      </div>
      {showLoadMore && (
        <div className="rc-resource-grid__show-more">
          <button className="t2-button t2-button--medium t2-button--primary " onClick={loadMoreHandler}>{ loadMoreText }</button>
        </div>
      )}
    </div>
  );
};
